import {
  CalendarIcon,
  ChartBarIcon,
  ChartPieIcon,
  CodeBracketIcon,
  Cog6ToothIcon,
  HomeIcon,
  LinkIcon,
  PaperAirplaneIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom'
import SiteSwitcher from './SiteSwitcher'

const seoNav = [
  { name: 'Dashboard', to: '/dashboard', icon: HomeIcon },
  { name: 'Keyword Tracking', to: '/tracking', icon: ChartBarIcon },
  { name: 'Submissions', to: '/submissions', icon: PaperAirplaneIcon },
  { name: 'Backlinks', to: '/backlinks', icon: LinkIcon },
  { name: 'Analytics', to: '/analytics', icon: ChartPieIcon },
]

const brandNav = [
  { name: 'Content Calendar', to: '/content', icon: CalendarIcon },
  { name: 'Brand Monitor', to: '/brand', icon: UserCircleIcon },
  { name: 'GitHub SEO', to: '/github-seo', icon: CodeBracketIcon },
]

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
    isActive
      ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300'
      : 'text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800'
  }`

export default function Sidebar() {
  return (
    <div className="flex w-64 flex-col border-r border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
      <div className="flex h-16 items-center border-b border-gray-200 px-6 dark:border-gray-700">
        <h1 className="text-xl font-bold text-primary-600 dark:text-primary-400">Brand SEO</h1>
      </div>

      <div className="border-b border-gray-200 px-3 py-3 dark:border-gray-700">
        <SiteSwitcher />
      </div>

      <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
        <p className="mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
          SEO
        </p>
        {seoNav.map((item) => (
          <NavLink key={item.name} to={item.to} className={navLinkClass}>
            <item.icon className="h-5 w-5" />
            {item.name}
          </NavLink>
        ))}

        <p className="mb-1 mt-4 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
          Personal Brand
        </p>
        {brandNav.map((item) => (
          <NavLink key={item.name} to={item.to} className={navLinkClass}>
            <item.icon className="h-5 w-5" />
            {item.name}
          </NavLink>
        ))}

        <p className="mb-1 mt-4 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
          Config
        </p>
        <NavLink to="/settings" className={navLinkClass}>
          <Cog6ToothIcon className="h-5 w-5" />
          Settings
        </NavLink>
      </nav>

      <div className="border-t border-gray-200 p-4 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-400">© 2026 Sven Thirion</p>
      </div>
    </div>
  )
}
